import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { RequestIframeError } from '../utils/error';
import { isExpectedAckMatch } from '../endpoint';
import { detectContentType } from '../utils/content-type';
import { isWindowAvailable } from '../utils/window';
import { generateRequestId, generateInstanceId } from '../utils/id';
import { CookieStore } from '../utils/cookie';
import { RequestInterceptorManager, ResponseInterceptorManager, runRequestInterceptors, runResponseInterceptors } from '../interceptors';
import { RequestIframeEndpointFacade, createReadableStreamFromStart } from '../endpoint';
import { autoResolveIframeFileReadableStream } from '../endpoint';
import { DefaultTimeout, ErrorCode, MessageType, MessageRole, HttpStatus, HttpStatusText, HttpHeader, Messages, formatMessage, StreamType as StreamTypeConstant } from '../constants';
import { isFunction } from '../utils/is';

/**
 * Client configuration options
 */

/**
 * RequestIframeClient implementation (only responsible for initiating requests, reuses server's listener)
 */
export class RequestIframeClientImpl {
  /** 
   * Target server ID (remembered from responses)
   * When a response is received, we remember the server's creatorId as the targetId for future requests
   */

  rememberTargetServerId(serverId) {
    if (!serverId) return;
    if (!this._targetServerId) {
      this._targetServerId = serverId;
      this.outbox.setDefaultTargetId(serverId);
    }
  }
  constructor(targetWindow, targetOrigin, options, instanceId) {
    var _options$ackTimeout, _options$timeout, _options$asyncTimeout, _options$returnData;
    /** Unique instance ID */
    _defineProperty(this, "interceptors", {
      request: new RequestInterceptorManager(),
      response: new ResponseInterceptorManager()
    });
    /** 
     * Internal cookies storage
     * - Automatically includes cookies matching the path when sending requests
     * - Automatically parses Set-Cookie and saves when receiving response
     */
    _defineProperty(this, "_cookieStore", new CookieStore());
    this.id = instanceId || generateInstanceId();
    this.targetWindow = targetWindow;
    this.targetOrigin = targetOrigin;
    this.secretKey = options === null || options === void 0 ? void 0 : options.secretKey;
    var endpoint = new RequestIframeEndpointFacade({
      role: MessageRole.CLIENT,
      instanceId: this.id,
      secretKey: options === null || options === void 0 ? void 0 : options.secretKey,
      autoAckMaxMetaLength: options === null || options === void 0 ? void 0 : options.autoAckMaxMetaLength,
      autoAckMaxIdLength: options === null || options === void 0 ? void 0 : options.autoAckMaxIdLength,
      inbox: {},
      streamDispatcher: {
        handledBy: this.id
      },
      originValidator: {
        allowedOrigins: options === null || options === void 0 ? void 0 : options.allowedOrigins,
        validateOrigin: options === null || options === void 0 ? void 0 : options.validateOrigin
      }
    });
    this.endpoint = endpoint;
    /** Core/routers shared composition */
    this.hub = endpoint.hub;
    this.streamDispatcher = endpoint.streamDispatcher;
    this.inbox = endpoint.inbox;
    this.originValidator = endpoint.originValidator;

    /** Create a fixed-peer sender (built-in client) */
    this.outbox = this.hub.createOutbox(this.targetWindow, this.targetOrigin);

    /**
     * Register base message infra + response handlers via facade.
     * These hooks will run when client.open() is called.
     */
    this.endpoint.onOpen(() => this.inbox.registerHandlers());

    // Provide fallback target for auto-ack (useful when MessageEvent.source is missing in tests)
    this.hub.setFallbackTarget(this.outbox.targetWindow, this.outbox.targetOrigin);

    // Set default timeout configuration
    this.defaultAckTimeout = (_options$ackTimeout = options === null || options === void 0 ? void 0 : options.ackTimeout) !== null && _options$ackTimeout !== void 0 ? _options$ackTimeout : DefaultTimeout.ACK;
    this.defaultTimeout = (_options$timeout = options === null || options === void 0 ? void 0 : options.timeout) !== null && _options$timeout !== void 0 ? _options$timeout : DefaultTimeout.REQUEST;
    this.defaultAsyncTimeout = (_options$asyncTimeout = options === null || options === void 0 ? void 0 : options.asyncTimeout) !== null && _options$asyncTimeout !== void 0 ? _options$asyncTimeout : DefaultTimeout.ASYNC;

    // Set default returnData configuration
    this.defaultReturnData = (_options$returnData = options === null || options === void 0 ? void 0 : options.returnData) !== null && _options$returnData !== void 0 ? _options$returnData : false;

    // Save initial headers configuration
    this.initialHeaders = options === null || options === void 0 ? void 0 : options.headers;

    // Stream dispatching is owned by facade (pluggable stream infra)
    this.endpoint.enableStreamDispatcherCallback({
      isOriginAllowed: (d, ctx) => this.hub.isOriginAllowedBy(ctx.origin, d, ctx, this.targetOrigin, this.originValidator)
    });
    this.endpoint.registerClientStreamCallbackHandlers({
      handlerOptions: this.hub.createHandlerOptions(() => {
        /** ignore version errors for stream frames */
      })
    });

    /** Auto-open by default (unless explicitly set to false) */
    if ((options === null || options === void 0 ? void 0 : options.autoOpen) !== false) {
      this.open();
    }
  }

  /**
   * Register stream message handler (StreamMessageHandler interface implementation)
   */
  registerStreamHandler(streamId, handler) {
    this.streamDispatcher.register(streamId, handler);
  }

  /**
   * Unregister stream message handler (StreamMessageHandler interface implementation)
   */
  unregisterStreamHandler(streamId) {
    this.streamDispatcher.unregister(streamId);
  }

  /*
   Send message (StreamMessageHandler interface implementation)
   */
  postMessage(message) {
    this.sendRaw(message);
  }

  /**
   * Send raw framework message (advanced).
   *
   * Note: streams call `postMessage` via StreamMessageHandler, which delegates here.
   */
  sendRaw(message) {
    // Window check is handled in MessageDispatcher
    this.outbox.sendRaw(message);
  }

  /**
   * Resolve header value (handle function type headers)
   */
  resolveHeaderValue(value, config) {
    if (isFunction(value)) {
      return value(config);
    }
    return value;
  }

  /**
   * Detect Content-Type for request body
   */
  detectContentTypeForBody(body) {
    return detectContentType(body, {
      checkStream: false
    });
  }

  /**
   * Check if header exists (case-insensitive)
   */
  hasHeader(headers, name) {
    var lower = name.toLowerCase();
    return Object.keys(headers).some(k => k.toLowerCase() === lower);
  }

  /**
   * Merge and resolve headers (initial headers + request headers)
   * Request headers take precedence over initial headers
   * Also auto-detects and sets Content-Type if not already set
   */
  mergeHeaders(config, body) {
    var resolvedHeaders = {};

    // First, resolve initial headers
    if (this.initialHeaders) {
      for (var _i = 0, _Object$entries = Object.entries(this.initialHeaders); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        resolvedHeaders[key] = this.resolveHeaderValue(value, config);
      }
    }

    // Then, merge request headers (request headers take precedence)
    if (config.headers) {
      for (var _i2 = 0, _Object$entries2 = Object.entries(config.headers); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];
        resolvedHeaders[_key] = this.resolveHeaderValue(_value, config);
      }
    }

    // Auto-detect and set Content-Type if not already set and body is provided
    if (body !== undefined && !this.hasHeader(resolvedHeaders, HttpHeader.CONTENT_TYPE)) {
      var contentType = this.detectContentTypeForBody(body);
      if (contentType) {
        resolvedHeaders[HttpHeader.CONTENT_TYPE] = contentType;
      }
    }
    return resolvedHeaders;
  }

  /**
   * Check if server is reachable
   */
  isConnect() {
    // Check if target window is still available before sending ping
    if (!isWindowAvailable(this.targetWindow)) {
      return Promise.reject(new RequestIframeError({
        message: Messages.TARGET_WINDOW_CLOSED,
        code: ErrorCode.TARGET_WINDOW_CLOSED,
        config: undefined,
        requestId: `ping_${Date.now()}`
      }));
    }
    return this.endpoint.pingIsConnect({
      peer: this.outbox,
      timeoutMs: this.defaultAckTimeout,
      targetOrigin: this.targetOrigin,
      targetId: this._targetServerId,
      onPeerId: serverId => this.rememberTargetServerId(serverId)
    });
  }
  send(path, body, options) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var config, processedConfig, processedBody;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _objectSpread({
              path,
              body
            }, options);
            _context.next = 1;
            return runRequestInterceptors(_this.interceptors.request, config);
          case 1:
            processedConfig = _context.sent;
            processedBody = processedConfig.body;
            return _context.abrupt("return", _this.outbox.send({
              data: processedBody,
              onFileOrBlob: () => {
                return _this.sendFile(path, processedBody, options);
              },
              onStream: () => {
                return _this.sendStream(path, processedBody, options);
              },
              onOther: () => {
                // Merge and resolve headers (initial headers + request headers)
                var mergedHeaders = _this.mergeHeaders(processedConfig, processedBody);
                var processedPath = processedConfig.path,
                  processedCookies = processedConfig.cookies,
                  userTargetId = processedConfig.targetId,
                  _processedConfig$requ = processedConfig.requestId,
                  requestId = _processedConfig$requ === void 0 ? generateRequestId() : _processedConfig$requ;
                var targetId = userTargetId || _this._targetServerId;
                return _this._sendRequest(processedPath, processedBody, mergedHeaders, processedCookies, processedConfig, requestId, targetId);
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }

  /**
   * Send file as request body (stream only; server receives stream or auto-resolved File/Blob via autoResolve).
   */
  sendFile(path, content, options) {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _processedConfig$requ2, _processedConfig$targ, _options$chunked, _options$autoResolve;
      var config, processedConfig, requestId, targetId, processedPath, mergedHeaders, pathMatchedCookies, mergedCookies, streamConfig;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            config = _objectSpread({
              path,
              body: undefined
            }, options);
            _context2.next = 1;
            return runRequestInterceptors(_this2.interceptors.request, config);
          case 1:
            processedConfig = _context2.sent;
            requestId = (_processedConfig$requ2 = processedConfig.requestId) !== null && _processedConfig$requ2 !== void 0 ? _processedConfig$requ2 : generateRequestId();
            targetId = (_processedConfig$targ = processedConfig.targetId) !== null && _processedConfig$targ !== void 0 ? _processedConfig$targ : _this2._targetServerId;
            processedPath = processedConfig.path;
            mergedHeaders = _this2.mergeHeaders(processedConfig, undefined);
            pathMatchedCookies = _this2._cookieStore.getForPath(processedPath);
            mergedCookies = _objectSpread(_objectSpread({}, pathMatchedCookies), processedConfig.cookies);
            streamConfig = _objectSpread(_objectSpread({}, processedConfig), {}, {
              requestId
            });
            return _context2.abrupt("return", _this2.outbox.sendFile({
              content,
              fileName: options === null || options === void 0 ? void 0 : options.fileName,
              mimeType: options === null || options === void 0 ? void 0 : options.mimeType,
              chunked: (_options$chunked = options === null || options === void 0 ? void 0 : options.chunked) !== null && _options$chunked !== void 0 ? _options$chunked : false,
              chunkSize: options === null || options === void 0 ? void 0 : options.chunkSize,
              autoResolve: (_options$autoResolve = options === null || options === void 0 ? void 0 : options.autoResolve) !== null && _options$autoResolve !== void 0 ? _options$autoResolve : true,
              defaultFileName: typeof File !== 'undefined' && content instanceof File ? content.name : 'file',
              defaultMimeType: 'application/octet-stream',
              stream: {
                bind: {
                  requestId,
                  registerStreamHandler: _this2.registerStreamHandler.bind(_this2),
                  unregisterStreamHandler: _this2.unregisterStreamHandler.bind(_this2),
                  heartbeat: () => _this2.isConnect(),
                  clientId: _this2.id,
                  targetId
                },
                awaitStart: false,
                beforeStart: ({
                  stream
                }) => {
                  return _this2._sendRequest(processedPath, undefined, mergedHeaders, mergedCookies, streamConfig, requestId, targetId, {
                    streamId: stream.streamId
                  });
                }
              }
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }

  /**
   * Send stream as request body (server receives readable stream).
   * Sends REQUEST with streamId and stream: true, then starts the writable stream.
   */
  sendStream(path, stream, options) {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _processedConfig$requ3, _processedConfig$targ2;
      var config, processedConfig, requestId, targetId, processedPath, mergedHeaders, pathMatchedCookies, mergedCookies, streamConfig;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            config = _objectSpread({
              path,
              body: undefined
            }, options);
            _context3.next = 1;
            return runRequestInterceptors(_this3.interceptors.request, config);
          case 1:
            processedConfig = _context3.sent;
            requestId = (_processedConfig$requ3 = processedConfig.requestId) !== null && _processedConfig$requ3 !== void 0 ? _processedConfig$requ3 : generateRequestId();
            targetId = (_processedConfig$targ2 = processedConfig.targetId) !== null && _processedConfig$targ2 !== void 0 ? _processedConfig$targ2 : _this3._targetServerId;
            processedPath = processedConfig.path;
            mergedHeaders = _this3.mergeHeaders(processedConfig, undefined);
            pathMatchedCookies = _this3._cookieStore.getForPath(processedPath);
            mergedCookies = _objectSpread(_objectSpread({}, pathMatchedCookies), processedConfig.cookies);
            streamConfig = _objectSpread(_objectSpread({}, processedConfig), {}, {
              requestId
            });
            return _context3.abrupt("return", _this3.outbox.sendStream({
              stream: stream,
              bind: {
                requestId,
                registerStreamHandler: _this3.registerStreamHandler.bind(_this3),
                unregisterStreamHandler: _this3.unregisterStreamHandler.bind(_this3),
                heartbeat: () => _this3.isConnect(),
                clientId: _this3.id,
                targetId
              },
              awaitStart: false,
              beforeStart: ({
                stream: s
              }) => {
                return _this3._sendRequest(processedPath, undefined, mergedHeaders, mergedCookies, streamConfig, requestId, targetId, {
                  streamId: s.streamId
                });
              }
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }

  /**
   * Internal: send REQUEST and wait for response (used by send, sendFile, sendStream).
   */
  _sendRequest(requestPath, body, mergedHeaders, processedCookies, processedConfig, requestId, targetId, extraPayload) {
    var _processedConfig$ackT = processedConfig.ackTimeout,
      ackTimeout = _processedConfig$ackT === void 0 ? this.defaultAckTimeout : _processedConfig$ackT,
      _processedConfig$time = processedConfig.timeout,
      timeout = _processedConfig$time === void 0 ? this.defaultTimeout : _processedConfig$time,
      _processedConfig$asyn = processedConfig.asyncTimeout,
      asyncTimeout = _processedConfig$asyn === void 0 ? this.defaultAsyncTimeout : _processedConfig$asyn,
      _processedConfig$requ4 = processedConfig.requireAck,
      requireAck = _processedConfig$requ4 === void 0 ? true : _processedConfig$requ4,
      streamTimeout = processedConfig.streamTimeout,
      ack = processedConfig.ack,
      _processedConfig$retu = processedConfig.returnData,
      returnData = _processedConfig$retu === void 0 ? this.defaultReturnData : _processedConfig$retu;
    return new Promise((resolve, reject) => {
      var done = false;
      var timeoutId = null;
      var cleanup = () => {
        if (timeoutId) clearTimeout(timeoutId);
        this.inbox.unregisterPendingRequest(requestId);
      };
      var fail = error => {
        if (done) return;
        done = true;
        cleanup();
        // Convert to RequestIframeError instance
        var errorInstance = error instanceof RequestIframeError ? error : new RequestIframeError(error);
        // Run response interceptors to allow error logging
        Promise.reject(errorInstance).catch(err => {
          // Run through response interceptors' rejected callbacks
          var promise = Promise.reject(err);
          this.interceptors.response.forEach(interceptor => {
            promise = promise.catch(e => {
              if (interceptor.rejected) {
                return interceptor.rejected(e);
              }
              return Promise.reject(e);
            });
          });
          return promise;
        }).catch(() => {
          // After interceptors, reject with original error
          reject(errorInstance);
        });
      };
      var setAckTimeout = () => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fail(new RequestIframeError({
            message: formatMessage(Messages.ACK_TIMEOUT, ackTimeout),
            code: ErrorCode.ACK_TIMEOUT,
            config: processedConfig,
            requestId
          }));
        }, ackTimeout);
      };
      var setRequestTimeout = () => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fail(new RequestIframeError({
            message: formatMessage(Messages.REQUEST_TIMEOUT, timeout),
            code: ErrorCode.TIMEOUT,
            config: processedConfig,
            requestId
          }));
        }, timeout);
      };
      var setAsyncTimeout = () => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fail(new RequestIframeError({
            message: formatMessage(Messages.ASYNC_REQUEST_TIMEOUT, asyncTimeout),
            code: ErrorCode.ASYNC_TIMEOUT,
            config: processedConfig,
            requestId
          }));
        }, asyncTimeout);
      };

      // Register to server's pending requests
      this.inbox.registerPendingRequest(requestId, data => {
        if (done) return;

        // Received ACK: server has received request
        if (data.type === MessageType.ACK) {
          // Optional ack match (ignore mismatched ACK)
          if (!isExpectedAckMatch(ack, data.ack)) {
            return;
          }
          // Remember server's creatorId as target server ID for future requests
          this.rememberTargetServerId(data.creatorId);
          // Switch to request timeout
          setRequestTimeout();
          return;
        }

        // Received ASYNC notification: this is an async task
        if (data.type === MessageType.ASYNC) {
          // Remember server's creatorId as target server ID for future requests
          this.rememberTargetServerId(data.creatorId);
          // Switch to async timeout
          setAsyncTimeout();
          return;
        }

        // Received stream start message
        if (data.type === MessageType.STREAM_START) {
          done = true;
          cleanup();

          // Remember server's creatorId as target server ID for future requests
          this.rememberTargetServerId(data.creatorId);
          var created = createReadableStreamFromStart({
            requestId,
            data,
            handler: this,
            secretKey: this.secretKey,
            idleTimeout: streamTimeout,
            heartbeat: () => this.isConnect()
          });
          if (!created) {
            fail(new RequestIframeError({
              message: formatMessage(Messages.STREAM_ERROR, 'invalid stream_start'),
              code: ErrorCode.STREAM_ERROR,
              config: processedConfig,
              requestId
            }));
            return;
          }
          var readableStream = created.stream,
            info = created.info;

          // File stream: optional auto-resolve to File/Blob
          if (info.type === StreamTypeConstant.FILE) {
            var fileStream = readableStream;
            if (info.autoResolve) {
              autoResolveIframeFileReadableStream({
                fileStream,
                info,
                headers: data.headers
              }).then(fileData => {
                var resp = {
                  data: fileData,
                  status: data.status || HttpStatus.OK,
                  statusText: data.statusText || HttpStatusText[HttpStatus.OK],
                  requestId,
                  headers: data.headers
                };
                return runResponseInterceptors(this.interceptors.response, resp);
              }).then(response => {
                resolve(returnData ? response.data : response);
              }).catch(reject);
              return;
            }
          }
          var resp = {
            data: undefined,
            status: data.status || HttpStatus.OK,
            statusText: data.statusText || HttpStatusText[HttpStatus.OK],
            requestId,
            headers: data.headers,
            stream: readableStream
          };
          runResponseInterceptors(this.interceptors.response, resp).then(response => {
            resolve(returnData ? response.data : response);
          }).catch(reject);
          return;
        }

        // Received response
        if (data.type === MessageType.RESPONSE) {
          done = true;
          cleanup();

          // Remember server's creatorId as target server ID for future requests
          this.rememberTargetServerId(data.creatorId);

          // Parse and save server-set cookies (from Set-Cookie header)
          if (data.headers && data.headers[HttpHeader.SET_COOKIE]) {
            var setCookies = data.headers[HttpHeader.SET_COOKIE];
            var setCookieArray = Array.isArray(setCookies) ? setCookies : [setCookies];
            var _iterator = _createForOfIteratorHelper(setCookieArray),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var setCookieStr = _step.value;
                this._cookieStore.setFromSetCookie(setCookieStr);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          var _resp = {
            data: data.data,
            status: data.status || HttpStatus.OK,
            statusText: data.statusText || HttpStatusText[HttpStatus.OK],
            requestId,
            headers: data.headers
          };
          runResponseInterceptors(this.interceptors.response, _resp).then(response => {
            resolve(returnData ? response.data : response);
          }).catch(reject);
          return;
        }

        // Received error
        if (data.type === MessageType.ERROR) {
          var _data$error, _data$error2;
          // Remember server's creatorId as target server ID for future requests
          this.rememberTargetServerId(data.creatorId);
          fail(new RequestIframeError({
            message: ((_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.message) || Messages.REQUEST_FAILED,
            code: ((_data$error2 = data.error) === null || _data$error2 === void 0 ? void 0 : _data$error2.code) || ErrorCode.REQUEST_ERROR,
            config: processedConfig,
            response: data.status ? {
              data: data.data,
              status: data.status,
              statusText: data.statusText || Messages.ERROR
            } : undefined,
            requestId
          }));
        }
      }, error => {
        fail(new RequestIframeError({
          message: error.message || Messages.REQUEST_FAILED,
          code: ErrorCode.REQUEST_ERROR,
          config: processedConfig,
          requestId
        }));
      }, this.targetOrigin, this.originValidator);

      // Set ACK timeout (delivery stage). If disabled, start request timeout immediately.
      if (requireAck === false) {
        setRequestTimeout();
      } else {
        setAckTimeout();
      }

      // Get cookies matching request path and merge with user-provided cookies (user-provided takes precedence)
      var pathMatchedCookies = this._cookieStore.getForPath(requestPath);
      var mergedCookies = _objectSpread(_objectSpread({}, pathMatchedCookies), processedCookies);

      // Send request via MessageDispatcher
      var payload = {
        path: requestPath,
        body,
        headers: mergedHeaders,
        cookies: mergedCookies,
        targetId,
        requireAck,
        ack
      };
      if (extraPayload !== null && extraPayload !== void 0 && extraPayload.streamId) {
        payload.streamId = extraPayload.streamId;
      }

      // Check if target window is still available before sending
      if (!isWindowAvailable(this.targetWindow)) {
        fail(new RequestIframeError({
          message: Messages.TARGET_WINDOW_CLOSED,
          code: ErrorCode.TARGET_WINDOW_CLOSED,
          config: processedConfig,
          requestId
        }));
        return;
      }
      this.outbox.sendMessage(MessageType.REQUEST, requestId, payload);
    });
  }
  /**
   * Get internal hub instance (for debugging)
   */
  getHub() {
    return this.hub;
  }

  /**
   * Whether message handling is enabled
   */
  get isOpen() {
    return this.hub.isOpen;
  }

  /**
   * Check if target window is still available (not closed/removed)
   * @returns true if target window is available, false otherwise
   */
  isAvailable() {
    return isWindowAvailable(this.targetWindow);
  }

  /**
   * Enable message handling (register message handlers)
   */
  open() {
    this.hub.open();
  }

  /**
   * Disable message handling (unregister message handlers, but don't release resources)
   */
  close() {
    this.hub.close();
  }

  /**
   * Destroy client (close and release all resources)
   */
  destroy() {
    // Clear cookies
    this._cookieStore.clear();

    // Clear stream handlers
    this.streamDispatcher.clear();

    // Clear interceptors
    this.interceptors.request.clear();
    this.interceptors.response.clear();

    // Destroy core (this will also release the message channel)
    this.hub.destroy();
  }

  /**
   * Get all cookies matching specified path
   * @param path Request path, returns all cookies if not provided
   */
  getCookies(path) {
    if (path) {
      return this._cookieStore.getForPath(path);
    }
    return this._cookieStore.getAllSimple();
  }

  /**
   * Get specified cookie
   * @param name Cookie name
   * @param path Path (optional)
   */
  getCookie(name, path) {
    return this._cookieStore.get(name, path);
  }

  /**
   * Set cookie
   * @param name Cookie name
   * @param value Cookie value
   * @param options Cookie options (path, etc.)
   */
  setCookie(name, value, options) {
    var _options$path;
    var expires;
    if (options !== null && options !== void 0 && options.expires) {
      expires = options.expires.getTime();
    } else if ((options === null || options === void 0 ? void 0 : options.maxAge) !== undefined) {
      expires = Date.now() + options.maxAge * 1000;
    }
    this._cookieStore.set({
      name,
      value,
      path: (_options$path = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path !== void 0 ? _options$path : '/',
      expires
    });
  }

  /**
   * Remove specified cookie
   * @param name Cookie name
   * @param path Path (optional, defaults to '/')
   */
  removeCookie(name, path) {
    this._cookieStore.remove(name, path !== null && path !== void 0 ? path : '/');
  }

  /**
   * Clear all cookies
   */
  clearCookies() {
    this._cookieStore.clear();
  }
}